import { useAuth } from "@/contexts/AuthContext";
import Dashboard from "./Dashboard";
import HostDashboard from "./HostDashboard";
import IndividualDashboard from "./IndividualDashboard";
import PropertyManagerDashboard from "./PropertyManagerDashboard";
import SystemAdminDashboard from "./SystemAdminDashboard";

// Note: "guest" role does not exist — guests access the app via tokenized
// links (/guest/:token) and never have a user account or role.
export default function RoleDashboard() {
  const { effectiveRole } = useAuth();

  switch (effectiveRole) {
    case "host":
      return <HostDashboard />;
    case "individual":
      return <IndividualDashboard />;
    case "property_manager":
      return <PropertyManagerDashboard />;
    case "system_admin":
      return <SystemAdminDashboard />;
    case "strata_admin":
    default:
      return <Dashboard />;
  }
}
